var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.778,
    height: 15.626,
    viewBox: "0 0 18.778 15.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.124 -343.933)",
    opacity: 0.696
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.187 344.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.989,15.37a2.685,2.685,0,1,1,2.661-2.685A2.685,2.685,0,0,1,35.989,15.37Zm0-4.722A2.037,2.037,0,1,0,38,12.685,2.037,2.037,0,0,0,35.989,10.648Z",
    transform: "translate(-30.756 -10)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.185,56.851a5.7,5.7,0,0,1-1.467-.324A9.658,9.658,0,0,0,22.943,56a11.063,11.063,0,0,0-2.787.459c-.961.251-1.655.431-2.1.088a1.018,1.018,0,0,1-.347-.87,5.233,5.233,0,0,1,10.465,0,1.153,1.153,0,0,1-.386,1,.972.972,0,0,1-.6.177Zm-4.242-1.5a10.11,10.11,0,0,1,2.964.559c.638.193,1.3.392,1.5.246.079-.06.123-.23.123-.486a4.584,4.584,0,0,0-9.169,0c0,.107.013.295.094.358.193.149.877-.029,1.539-.2A11.758,11.758,0,0,1,22.943,55.348Z",
    transform: "translate(-17.71 -43.887)",
    stroke: "#000",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1563.4,70.821l-3.707,1.382-1.031,2.575-.228,1.671,5.2-.771,5.062,1.062-.223-2.912-1.144-1-1.528-1.337Z",
    transform: "translate(-1510.14 281.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.431,16.247a3.123,3.123,0,1,1,3.095-3.123A3.123,3.123,0,0,1,36.431,16.247Zm0-5.492a2.369,2.369,0,1,0,2.341,2.369A2.369,2.369,0,0,0,36.431,10.754Z",
    transform: "translate(17.029 334.229)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.731,57.9a6.627,6.627,0,0,1-1.706-.377A11.234,11.234,0,0,0,23.8,56.9a12.869,12.869,0,0,0-3.242.533c-1.118.292-1.924.5-2.441.1a1.184,1.184,0,0,1-.4-1.012,6.086,6.086,0,0,1,12.172,0,1.341,1.341,0,0,1-.449,1.165A1.131,1.131,0,0,1,28.731,57.9ZM23.8,56.149a11.759,11.759,0,0,1,3.447.65c.743.224,1.508.456,1.742.286.092-.07.143-.268.143-.565a5.332,5.332,0,0,0-10.665,0c0,.124.015.343.109.417.224.173,1.02-.034,1.791-.236A13.676,13.676,0,0,1,23.8,56.149Z",
    transform: "translate(29.664 301.411)",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewUser);
export default __webpack_public_path__ + "static/media/ReviewUser.cc5aec442b1adf2beefa1b7a24ce9f12.svg";
export { ForwardRef as ReactComponent };